import B2CLedger from "../../components/dashboard/B2CLedger";

const B2CLedgerPage = () => {
  return (
    <div className="p-3 md:p-5 space-y-4 bg-gray-50 min-h-screen">
      <B2CLedger />
    </div>
  );
};

export default B2CLedgerPage;
